import {
  FETCH_UNITS,
  FETCH_UNITS_SUCCESS,
  FETCH_UNITS_FAILURE,
  CREATE_UNIT,
  CREATE_UNIT_SUCCESS,
  CREATE_UNIT_FAILURE,
} from "./actionTypes";

// Fetch Units
export const fetchUnits = () => ({
  type: FETCH_UNITS
});

export const fetchUnitsSuccess = (unitId) => ({
  type: FETCH_UNITS_SUCCESS,
  payload: unitId,
});

export const fetchUnitsFailure = (error) => ({
  type: FETCH_UNITS_FAILURE,
  payload: error,
});

export const createUnit = (formData) => ({ type: CREATE_UNIT, payload: {formData} });
export const createUnitSuccess = (unit) => ({ type: CREATE_UNIT_SUCCESS, payload: unit });
export const createUnitFailure = (error) => ({ type: CREATE_UNIT_FAILURE, payload: error });
